import { DatePipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { getLabelRoleUser } from '@noovle/core';


@Pipe({
  name: 'formatter',
  standalone: true
})
export class FormatterPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe, private datePipe: DatePipe) {}

  transform(value: any, args: any = {}): any {
    switch (args.type) {
      case 'date':
        return this.datePipe.transform(value, args.format);
      case 'role':
        return getLabelRoleUser(value);
      case 'length':
        return value.length;
      case 'subKey':
        return this.getSubKey(value);
      case 'state':
        return this.getState(value);
      default:
        return value;
    }
  }

  getSubKey(value: any) {
    return value.name;
  }

  getState(value: boolean) {
    if (value) {
      return 'Pubblica';
    } else {
      return 'Non pubblica';
    }
  }
}
